import { StyledCell } from '../Table.style';
import Chip from 'components/base/Chip';
import { setQueryFilter } from 'components/GridChipFilterContainer/helpers';
import get from 'lodash/get';

const STATUSES_COLORS = {
  open: 'error',
  'in-progress': 'warning',
  closed: 'success'
};

const StatusCell = ({ status }) => {
  const color = get(STATUSES_COLORS, status);
  return (
    <StyledCell>
      <Chip
        label={status}
        size='auto'
        variant='outlined'
        color={color}
        onClick={() => setQueryFilter({ status })}
      />
    </StyledCell>
  );
};

export default StatusCell;
